import { defineComponent, computed, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import UiValue from '../ui-value/UiValue.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioHeader",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true }
  },
  emits: ["store-error", "data-load"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const componentInputs = computed(() => ({
      id: props.id,
      language: props.locale
    }));
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, textFormat, numberFormat, dateFormat } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, isLoadingStoreData } = storeModule;
    return { __sfc: true, props, emits, componentInputs, localizationSupport, translate, textFormat, numberFormat, dateFormat, storeModule, storeData, isLoadingStoreData, UiValue, HoistComponent };
  }
});

export { _sfc_main as default };
